import { GradientButton } from "@/components/ui/gradient-button";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export const CallToAction = () => {
  const { t } = useTranslation();

  return (
    <div className="container mx-auto px-4 py-16 text-center">
      <h2 className="text-3xl font-bold mb-6">{t('cta.title')}</h2>
      <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
        {t('cta.description')}
      </p>
      <GradientButton asChild>
        <Link to="/signup">
          {t('cta.button')}
          <ArrowRight className="ml-2" />
        </Link>
      </GradientButton>
    </div>
  );
};